import type { CompRef } from '@wix/document-services-types';
import type { EditorAPI } from '#packages/editorAPI';
import type { BreakpointData } from './types';

export const getBreakpoint = (
  editorAPI: EditorAPI,
  pageRef: CompRef,
  breakpointMinRange: number,
): BreakpointData => {
  const pageBreakpoints = editorAPI.breakpoints.get(pageRef);
  if (!pageBreakpoints) {
    throw new Error('No breakpoints found');
  }

  // TODO: is it the right way to check for breakpoints?
  const desktopBreakpointDefinition = pageBreakpoints.values.find(
    ({ min }) => min === breakpointMinRange,
  );
  if (!desktopBreakpointDefinition) {
    throw new Error('No desktop breakpoint found');
  }
  const pointer = pageBreakpoints.pointers.find(
    ({ id }) => id === desktopBreakpointDefinition.id,
  );
  return {
    pointer,
    value: desktopBreakpointDefinition,
  };
};
